export const DimensionTypeEnumValue = {
  Inch: 0,
  Cm: 10,
};

export const DimensionTypeEnum = [
  {
    value: DimensionTypeEnumValue.Inch,
    name: 'Inch',
    labelFrench: 'Pouce',
    labelEnglish: 'Inch',
  },
  {
    value: DimensionTypeEnumValue.Cm,
    name: 'Cm',
    labelFrench: 'Cm',
    labelEnglish: 'Cm',
  },
];

export default DimensionTypeEnum;
